import { Formatted } from '@/ui/formatted/formatted.component';
import React, { ComponentType } from 'react';
import AsyncSelect from 'react-select/async';
import { Translator } from 'shared/translator/translator.component';
import {
  FindProductsQuery,
  useFindProductsQuery,
} from './product-finder.generated';

import styles from './product-finder.module.scss';

type FoundProduct = FindProductsQuery['adminProducts']['data'][number];

function getProductLabel(product: FoundProduct, _: any) {
  return (
    <>
      {product.title}
      <br />
      <Formatted.Currency value={product.amount} />
      {(product.startDate || product.endDate) && (
        <>
          {' · '}
          {product.startDate ? (
            <Formatted.Date value={product.startDate} />
          ) : (
            'ab Buchung'
          )}
          {' – '}
          {product.endDate ? <Formatted.Date value={product.endDate} /> : '?'}
        </>
      )}
    </>
  );
}

function toItem(product: FoundProduct, _: any): ProductItemType {
  return {
    label: getProductLabel(product, _) as any,
    value: product.id,
    amount: product.amount,
    startDate: product.startDate ?? null,
    endDate: product.endDate ?? null,
  };
}

export type ProductItemType = {
  label: string;
  value: string;
  amount: number;
  startDate?: string | null;
  endDate?: string | null;
};
interface ProductFinderProps {
  value?: ProductItemType | null;
  onChange: (item?: ProductItemType | null) => void;
}

export const ProductFinder: ComponentType<ProductFinderProps> = (props) => {
  const { value, onChange } = props;
  const _ = Translator.useTranslator();

  const { data, refetch } = useFindProductsQuery({ variables: { query: '' } });
  return (
    <div className={styles.host}>
      <label>Suche</label>
      <AsyncSelect<ProductItemType>
        onChange={onChange}
        value={value}
        defaultOptions={
          data?.adminProducts.data.map((product) => toItem(product, _)) || []
        }
        loadOptions={async (inputValue: string, callback) => {
          try {
            const data = await refetch({
              query: inputValue,
            });
            callback(
              data.data?.adminProducts.data.map((product) =>
                toItem(product, _),
              ) ?? [],
            );
          } catch (e) {
            console.log(e);
          }
        }}
      />
    </div>
  );
};
